/**
 * 誌面印刷 出力リクエスト用VO
 *
 * @export KomaPrintDataModel
 * @class KomaPrintDataModel
 */
export class KomaPrintDataModel {
  // 印刷条件
  public orderCode = String('');
  public catalogId = String('');
  public mediumType = String('');
  public mediumName = String('');
  public coopCode = String('');
  public coopName = String('');

  // 表示条件
  public showKoma = String('');
  public showGoods = String('');
  public showImage = String('');

  /**
   * ページ一覧
   */
  public pageArray: Array<any> = new Array<any>();

  /**
   * 会員生協コードコード
   */
  public coopCodeList: Array<any> = new Array<any>();
}
